const typographyPlugin = require('tailwind-utils/typography.plugin');

const colorsConfig = require('./configs/tailwind.colors');
const typographyConfig = require('./configs/tailwind.typography');
const proseConfig = require('./configs/tailwind.prose');

const fontFamily = {
  primary: `var(--font-primary), Arial, sans-serif`,
  secondary: `Georgia, Times New Roman, serif`,
  tertiary: `var(--font-tertiary), Arial, sans-serif`,
};

/** @type {import('tailwindcss').Config} */

module.exports = {
  theme: {
    extend: {
      fontFamily,
      colors: colorsConfig,

      typography: proseConfig(typographyConfig),
    },
  },
  safelist: ['text-black', 'text-white', 'text-primary-700'],
  plugins: [typographyPlugin(typographyConfig)],
};
